import React, {useContext} from 'react';
import block from 'bem-cn-lite';
import StickyBox from 'react-sticky-box';
import {TrashBin} from '@gravity-ui/icons';
import {Button, Text} from '@gravity-ui/uikit';
import {BrandFilter, Option, RangeGroup} from './components';
import {AsyncSearchState, FilterRangeModel, FiltersModel} from '@features/search/interfaces';
import {SearchContext} from '@features/search/context';
import {AppContext} from '@app/context';
import {PriceLevelSettings} from '@app/priceLevelSettings';

import './Filters.scss';

const b = block('filters');

const stickyElementsTopOffset = 147; // TODO Вынести в общие константы (дубль в SearchPage.tsx)

export interface FiltersProps {
    filters: FiltersModel;
    onFiltersChange?: (filters: FiltersModel) => void;
}

export const Filters: React.FC<FiltersProps> = ({ filters, onFiltersChange }) => {
    const {state, emit} = useContext(AppContext);
    const settings = state.priceLevelSettings;
    const searchContext = useContext(SearchContext);
    function handle(filtersParam: FiltersModel) {
        if (onFiltersChange) onFiltersChange(filtersParam);
    }

    function clearFilters() {
        handle({
            brands: filters.brands.map((x) => {
                return { ...x, isSelected: false };
            }),
            priceRange: getEmptyRange(filters.priceRange),
            deliveryDayRange: getEmptyRange(filters.deliveryDayRange),
            ratingRange: getEmptyRange(filters.ratingRange),
            quantityRange: getEmptyRange(filters.quantityRange),
            isReturnPossible: false,
            isOfficialDealer: false,
            priceLevel: filters.priceLevel,
        });
    }

    function handlePriceLevelChange(value: boolean) {
        emit('updatePriceLevelSettings', {
            settings: {
                ...settings,
                enabled: value,
            } as PriceLevelSettings
        });

        handle({ ...filters, priceLevel: value });
    }

    function getEmptyRange(range: FilterRangeModel) {
        return { ...range, from: undefined, to: undefined };
    }

    return (
        <StickyBox offsetTop={stickyElementsTopOffset} className={b('filter-sticky')}>
            <div className={b()}>
                <div className={b('filter-header')}>
                    <Text variant='subheader-3' className={b('filter-title')}>Фильтры</Text>
                    <Button size="m" onClick={clearFilters}>
                        <TrashBin />
                    </Button>
                </div>
                <div className={b('filter-controls')}>
                    <BrandFilter
                        brands={filters.brands}
                        onBrandsChange={(brands) => handle({ ...filters, brands: brands })}
                    ></BrandFilter>
                    <RangeGroup
                        title="Цена, ₽"
                        range={filters.priceRange}
                        onRangeChange={(range) => handle({ ...filters, priceRange: range })}
                        isCurrency={true}
                    ></RangeGroup>
                    <RangeGroup
                        title="Срок доставки, дни"
                        range={filters.deliveryDayRange}
                        onRangeChange={(range) => handle({ ...filters, deliveryDayRange: range })}
                    ></RangeGroup>
                    <RangeGroup
                        title="Рейтинг, %"
                        range={filters.ratingRange}
                        onRangeChange={(range) => handle({ ...filters, ratingRange: range })}
                    ></RangeGroup>
                    <RangeGroup
                        title="В наличии, шт."
                        range={filters.quantityRange}
                        onRangeChange={(range) => handle({ ...filters, quantityRange: range })}
                    ></RangeGroup>
                    <div className={b('filter-options')}>
                        <Option
                            title="Возвратность"
                            value={filters.isReturnPossible}
                            onValueChange={(value) => handle({ ...filters, isReturnPossible: value })}
                        ></Option>
                        <Option
                            title="Офиц. дилер"
                            value={filters.isOfficialDealer}
                            onValueChange={(value) => handle({ ...filters, isOfficialDealer: value })}
                        ></Option>
                        {(settings?.displayInSearchResults && settings?.markupPercentage) ? <Option
                            title="Уровень цен"
                            disabled={searchContext.state === AsyncSearchState.Searching}
                            value={filters.priceLevel}
                            onValueChange={(value) => handlePriceLevelChange(value)}
                        ></Option> : null}
                    </div>
                </div>
            </div>
        </StickyBox>
    );
};
